import { action, observable } from 'mobx'
import { createContext } from 'react'

import { BaseStore } from './BaseStore'

export const DEFAULT_BILLING_FILTERS = {
  dealerGroup: [],
  manufacturer: [],
  team: [],
  billingStatus: [],
  billingPeriod: [],
}

const INITIAL_STATE = {
  selectedFilters: DEFAULT_BILLING_FILTERS,
  sortedColumn: 'name',
  currentPage: 1,
  perPage: 20,
  searchTerm: null,
}

const TYPES = {
  selectedFilters: observable,
  sortedColumn: observable,
  currentPage: observable,
  perPage: observable,
  searchTerm: observable,
}

export class BillingFilterStore extends BaseStore {
  setSelectedFilters = action((filters) => {
    this.selectedFilters = filters
  })

  setSortedColumn = action((column) => {
    this.sortedColumn = column
  })

  setCurrentPage = action((page) => {
    this.currentPage = page
  })

  setPerPage = action((perPage) => {
    this.perPage = perPage
  })

  setSearchTerm = action((term) => {
    this.searchTerm = term
  })

  clearContext = action(() => {
    this.selectedFilters = DEFAULT_BILLING_FILTERS
    this.sortedColumn = 'name'
    this.currentPage = 1
    this.perPage = 20
    this.searchTerm = null
  })
}

export const billingFilter = new BillingFilterStore(INITIAL_STATE, TYPES)
export const BillingFilterStoreContext = createContext(billingFilter)
